import { useCallback } from 'react';
import { useTranslation } from 'react-i18next';
import { GridColDef } from '@mui/x-data-grid-pro';
import { useWorkRulesQuery } from './useWorkRulesQuery';
import { useWorkRulesTableState } from './useWorkRulesTableState';

export const useWorkRulesTable = () => {
    const { t } = useTranslation();
    const { rows, setRows, loading, setLoading, loadData } = useWorkRulesQuery();
    const { contextMenu, setContextMenu, selectedRow, setSelectedRow, selected, setSelected, cleanSelected } = useWorkRulesTableState();

    const columns: GridColDef[] = [
        { field: 'name', headerName: t('settings.work_rules.table.columns.name'), flex: 1 },
        { field: 'description', headerName: t('settings.work_rules.table.columns.description'), flex: 1 },
        { field: 'rounding_rule', headerName: t('settings.work_rules.table.columns.rounding'), flex: 1 },
        { field: 'exception_rule', headerName: t('settings.work_rules.table.columns.exception'), flex: 1 },
        { field: 'paycodes_distribution', headerName: t('settings.work_rules.table.columns.paycode_distribution'), flex: 1 },
    ];

    const reloading = useCallback(() => {
        const permissions = JSON.parse(localStorage.getItem('permissions') || '[]') as string[];
        const canReadWorkRules = permissions.includes('timekeeper.WorkRule');

        if (canReadWorkRules) {
            loadData().finally(() => {
                setContextMenu(null);
                cleanSelected();
            });
        } else {
            setRows([]);
            setLoading(false);
        }
    }, [cleanSelected, loadData, setContextMenu, setLoading, setRows]);

    return {
        rows,
        loading,
        loadData,
        reloading,
        selectedRow,
        setSelectedRow,
        contextMenu,
        setContextMenu,
        selected,
        setSelected,
        columns,
        cleanSelected,
    };
};
